/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { DashboardOutlined } from '@ant-design/icons';
import { routePermission } from 'utils/permission/index';
import Tramites from 'routes/Tramites';
import Catastro from 'routes/Catastro';

import Dashboard from 'views/Dashboard';
import LeyDeIngresos from './LeyDeIngresos';
import ProcesosMasivos from './ProcesosMasivos';
import Recaudacion from './Recaudacion';
import Padrones from './Padrones';
import Convenios from './Convenios';
import CatalogosDeRecaudacion from './CatalogosDeRecaudacion';
import Contabilidad from './Contabilidad';
import Configuracion from './Configuracion';
import PAE from './PAE';

// const Dashboard = React.lazy(() => import('../views/Dashboard/index'));
// const Recaudacion = React.lazy(() => import('./Recaudacion'));
// const Padrones = React.lazy(() => import('./Padrones'));
// const CatalogosDeRecaudacion = React.lazy(() => import('./CatalogosDeRecaudacion'));
// const Contabilidad = React.lazy(() => import('./Contabilidad'));
// const Configuracion = React.lazy(() => import('./Configuracion'));
// const Convenios = React.lazy(() => import('./Convenios'));
// const Tramites = React.lazy(() => import('./Tramites'));
// const Arcos = React.lazy(() => import('./Arcos'));
// const LeyDeIngresos = React.lazy(() => import('./LeyDeIngresos'));

const initialRoutes = [
  {
    title: 'Dashboard',
    icon: () => <DashboardOutlined />,
    component: Dashboard,
  },
  Recaudacion,
  Tramites,
  LeyDeIngresos,
  ProcesosMasivos,
  Padrones,
  Convenios,
  PAE,
  CatalogosDeRecaudacion,
  Contabilidad,
  Configuracion,
  Catastro,
].filter((e) => e);

const normalizeRoutes = (
  routes = [],
  parentPath = '',
  validate = true,
) => routes.filter((e) => e).map((_r) => {
  const r = { ..._r };
  r.path = (`${parentPath}/${r.title}`)
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').toLowerCase();
  if (r.children) {
    const children = normalizeRoutes(r.children, r.path, validate);
    if (!children.length) return null;
    return {
      path: r.path,
      title: r.title,
      icon: r.icon,
      children,
    };
  }
  r.permissionConfig = {
    permissionModel: r.permissionConfig?.permissionModel || r.permissionModel,
    catalogsModels: r.permissionConfig?.catalogsModels || r.catalogsModels || [],
    tabsModels: r.permissionConfig?.tabsModels || r.tabsModels || [],

    mainPermission: r.permissionConfig?.mainPermission,
    required: r.permissionConfig?.required || [],
    customActions: r.permissionConfig?.customActions || [],
    customSections: r.permissionConfig?.customSections || [],
  };

  const hasPermission = !validate || routePermission(r.path, r.permissionConfig);
  if (hasPermission) {
    return {
      path: r.path,
      title: r.title,
      icon: r.icon,
      component: r.component,
      permissionConfig: r.permissionConfig,
      showInSidebar: 'showInSidebar' in r ? r.showInSidebar : true,
      withoutLayout: 'withoutLayout' in r ? r.withoutLayout : false,
      componentProps: r.componentProps,
    };
  }
  return null;
}).filter((e) => e);

const routesToArray = (routes) => routes.map((r) => (r.children ? routesToArray(r.children) : r));

export const getFlattedRoutes = (routes = []) => routesToArray(routes).flat(Infinity);

export const getRoutes = (validate = true) => normalizeRoutes(initialRoutes, '', validate).map((r, _, arr) => {
  if (r.path === '/dashboard') {
    const _routes = getFlattedRoutes(arr);
    if (_routes.length === 2 && !_routes[1].withoutLayout) return { ...r, showInSidebar: false };
  }
  return r;
});
